//export const ADMIN_API_BASE_URL = 'https://emp-payroll-backend.onrender.com'
//https://api.grmarinesg.com
export const ADMIN_API_BASE_URL = 'https://api.grmarineservice.in'
export const ADMIN_COMPANY = '/admin/company'
export const ADMIN_TEAM = '/admin/team'
export const ADMIN_PROJECT = '/admin/project'
export const ADMIN_DORMMITORY = "/admin/getDormitoryDetails"
export const ADMIN_DESIGNATION = '/admin/designation'
export const ADMIN_EMPLOYEE = '/admin/employee'
export const ADMIN_EMPLOYEE_GET = '/admin/getEmployeeByCompany'
export const ADMIN_EMPLOYEE_PUT = '/admin/employee/'
export const ADMIN_TRUCK_TRIP_VIWE = '/admin/gettruckTripList?company_id='
export const ADMIN_TRUCK_TRIP = '/admin/truckTrip'
export const ADMIN_TRUCK_TRIP_PUT = '/admin/tripUpdateTruck/'
export const ADMIN_ATTENDANCE = '/admin/attendance'
export const ADMIN_ATTENDANCE_PUT = '/admin/attendanceUpdate/'
export const ADMIN_DRIVER_PAYROLL = '/admin/driver-payroll-generate'
export const ADMIN_WORKER_PAYROLL = '/admin/employee-payroll-generate'
export const ADMIN_EMPLOYEE_PAY_LIST = '/admin/employee-pay-list-details?pay_month=' //REFER
export const ADMIN_ADVANCE_ADD = '/admin/employee-advance-add'
export const ADMIN_ADVANCE = '/admin/employee-advance-list?company_id='
export const ADMIN_SALARY_DETAILS_ADD = '/admin/employeeSalaryDetails'
export const ADMIN_SALARY_DETAILS = '/admin/employeeSalaryDetails?company_id='
export const ADMIN_SALARY_PUT = '/admin/employeeSalary/'
export const ADMIN_EMPLOYEE_ATTENDANCE_REPORT = '/admin/attendance/byuser?company_id='
export const ADMIN_DORMITORY_DETAILS = '/admin/getDormitoryDetailsByUser'
export const ADMIN_EMPLOYEE_PAY_DETAILS = '/admin/employeePayDetailDateRange?startDate='
export const ADMIN_EMPLOYEE_PAY_ROLL = '/admin/employee-pay-details?pay_month='
export const ADMIN_EMPLOYEE_PAYDETAIL_DATERANGE = '/admin/employeePaydetailDateRangeByUserID?startDate='
export const ADMIN_EMPLOYEE_ATTENDANCE_REPORT_BY_DATE = '/admin/employeeAdvancedetailDateRange?startDate='
export const ADMIN_TRUCK_TRIP_REPORT = '/admin/getTruckTripDetailsByDateRange?startDate='
export const ADMIN_TEAM_MEMBER_DETAILS = '/admin/teamDetails'